import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, Stack, Row, Col, Container } from "react-bootstrap";
import {
  CardDataLabel,
  CardTitle,
  CardDataValue,
} from "../components/card_components";
import { fetchSupportTicketDetailsRequest } from "@/services";
import { SupportHeader } from "./support_header";


const STATUS_UI_MAP = {
  under_review: { label: "Under review", bg: "#FFF4CC", color: "#B88200" },
  resolved: { label: "Resolved", bg: "#E6F4F1", color: "#1F8A70" },
};

const formatDateTime = (date) => {
  if (!date) return "-";
  const d = new Date(date);
  return isNaN(d)
    ? "-"
    : d.toLocaleString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
};

export function SupportTicketDetails() {
  const { ticketId } = useParams();
  const [ticket, setTicket] = useState(null);

  useEffect(() => {
    loadTicket();
  }, [ticketId]);

  const loadTicket = async () => {
    const res = await fetchSupportTicketDetailsRequest(ticketId);
    const data = res?.results || res?.data || res;
    setTicket(data);
  };

  if (!ticket) return null;

  const statusUI =
    STATUS_UI_MAP[ticket.status] || {
      label: "Unknown",
      bg: "#ECECEC",
      color: "#666",
    };

  return (
    <Container fluid>
      <SupportHeader
        breadcrumb={`Dashboard > My tickets > #${ticket.id}`}
        title="Ticket details"
      />
      <Row className="g-3">
        <Col xs={12} xl={8}>
          <Card className="border-0 rounded-lg m-2">
            <Card.Body className="px-4 py-4">
              <Stack gap={4}>
                {/* HEADER */}
                <Stack direction="horizontal">
                  <CardTitle title="Ticket information" csx="me-auto" />
                  <span
                    style={{
                      background: statusUI.bg,
                      color: statusUI.color,
                      padding: "6px 16px",
                      borderRadius: 20,
                      fontSize: 13,
                      fontWeight: 500,
                    }}
                  >
                    {statusUI.label}
                  </span>
                </Stack>

                <hr className="my-0" />

                {/* META */}
                <Row className="gy-4">
                  <Col sm={6}>
                    <Stack gap={1}>
                      <CardDataLabel title="Submission date" />
                      <CardDataValue title={formatDateTime(ticket.created)} />
                    </Stack>
                  </Col>

                  <Col xs={12}>
                    <Stack gap={1}>
                      <CardDataLabel title="Subject" />
                      <CardDataValue title={ticket.subject || "-"} />
                    </Stack>
                  </Col>

                  <Col xs={12}>
                    <Stack gap={1}>
                      <CardDataLabel title="Your message" />
                      <CardDataValue title={ticket.description || "-"} />
                    </Stack>
                  </Col>

                  {/* ATTACHMENTS LIST */}
                  {ticket.attachments_files?.length > 0 && (
                    <Col xs={12}>
                      <Stack gap={2}>
                        <CardDataLabel title="Attachments" />
                        {ticket.attachments_files.map((file) => (
                          <a
                            key={file.uuid}
                            href={file.file_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary"
                            style={{ display: "block", fontSize: 14 }}
                          >
                            {file.file_name}
                          </a>
                        ))}
                      </Stack>
                    </Col>
                  )}

                  {/* RESOLUTION */}
                  {ticket.admin_remarks && (
                    <Col xs={12}>
                      <Card
                        className="border-0"
                        style={{
                          background: "#E9FBF4",
                          borderRadius: 12,
                        }}
                      >
                        <Card.Body className="p-3">
                          <Stack gap={1}>
                            <CardDataLabel title="Resolutions" />
                            <CardDataValue title={ticket.admin_remarks} />
                          </Stack>
                        </Card.Body>
                      </Card>
                    </Col>
                  )}
                </Row>
              </Stack>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
